// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"93bea461","160":"0c352337","208":"69ffa92c","293":"0d8f8106","516":"d3f345e9","519":"3637ba7a","917":"3ac1b942","946":"0a98d851"}[chunkId] + ".chunk.js";
};